import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
   OptionLableWrapper,
} from 'admin/views/site-designer/modules/sections/modules';

const SizeSection = ({
   options,
   value,
   onChange,
   name,
   isContentSize = false,
}) => {

   return (
      <div className='flex gap-4'>
         {
            options && options.map((size, index) => {
               const isSelected = size === value;
               return (
                  <OptionLableWrapper
                     key={ index.toString() }
                     isSelected={ isSelected }
                     title={ size }
                     onClick={ _ => onChange(name, size) }
                  >
                     <div
                        className={ cx({
                           'rounded-sm': true,
                           'bg-action': isSelected,
                           'bg-secondary': !isSelected,
                           'w-3 h-3': 'small' === size,
                           'w-4 h-4': 'medium' === size,
                           'w-5 h-5': 'large' === size,
                           '!w-8 !h-[18px]': 'small' === size && isContentSize,
                           '!w-10 !h-[23px]': 'medium' === size && isContentSize,
                           '!w-[53px] !h-[30px]': 'large' === size && isContentSize,
                        }) }
                     />
                  </OptionLableWrapper>

               )
            })
         }
      </div>

   )
}

SizeSection.propTypes = {
   options: PropTypes.array,
   value: PropTypes.any,
   onChange: PropTypes.func,
   name: PropTypes.string,
   isContentSize: PropTypes.string,
};

export default SizeSection;
